import { render } from "./event_create.vue?vue&type=template&id=66da4cc3&scoped=true"
import script from "./event_create.vue?vue&type=script&lang=js"
export * from "./event_create.vue?vue&type=script&lang=js"

import "./event_create.vue?vue&type=style&index=0&id=66da4cc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66da4cc3"]])

export default __exports__